import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "time_table" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_date_pager = _resolveComponent("date-pager")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_title, { value: "午睡チェック" }),
    _createVNode(_component_date_pager, { class: "pt-4" }),
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tr", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
          return _createElementVNode("td", {
            onClick: ($event: any) => (_ctx.selectedHour = (n - 1)),
            key: n
          }, _toDisplayString(n - 1), 9, _hoisted_2)
        }), 64))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
          return _createElementVNode("td", {
            onClick: ($event: any) => (_ctx.selectedHour = (n + 11)),
            key: n
          }, _toDisplayString(n + 11), 9, _hoisted_3)
        }), 64))
      ]),
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minutesList, (item) => {
          return (_openBlock(), _createElementBlock("td", { key: item }, _toDisplayString(_ctx.selectedHour + ':' + item), 1))
        }), 128))
      ])
    ])
  ]))
}